// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loadingButton_master__a-bQM {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
}
.loadingButton_container__\\+y2x3 {
  display: inline-flex;
  column-gap: 5px;
  align-content: stretch;
  height: 100%;
}

.loadingButton_img_container__diNhA {
  /*height: 30px;*/
  background-color: aquamarine;
  /* background-color: coral;*/
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/LoadingButton/loadingButton.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,4BAA4B;AAC9B","sourcesContent":[".master {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n.container {\n  display: inline-flex;\n  column-gap: 5px;\n  align-content: stretch;\n  height: 100%;\n}\n\n.img_container {\n  /*height: 30px;*/\n  background-color: aquamarine;\n  /* background-color: coral;*/\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"master": `loadingButton_master__a-bQM`,
	"container": `loadingButton_container__+y2x3`,
	"img_container": `loadingButton_img_container__diNhA`
};
export default ___CSS_LOADER_EXPORT___;
